export enum ClientInterviewStatus {
  Initial = 0,
  Scheduled = 1,
  Started = 2,
  Succeded = 3,
  Failed = 4,
}
